import { render, staticRenderFns } from "./GlobalUploader.vue?vue&type=template&id=0bd658ce"
import script from "./GlobalUploader.vue?vue&type=script&lang=js"
export * from "./GlobalUploader.vue?vue&type=script&lang=js"
import style0 from "./GlobalUploader.vue?vue&type=style&index=0&id=0bd658ce&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports